"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./CampaignItemOption.scss");

var _excluded = ["onChange", "onClick", "checked", "hover"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var CampaignItemOption = function CampaignItemOption(_ref) {
  var onChange = _ref.onChange,
      onClick = _ref.onClick,
      checked = _ref.checked,
      hover = _ref.hover,
      props = _objectWithoutProperties(_ref, _excluded);

  var changeHandler = function changeHandler(e) {
    var val = e.target.value;
    if (isNaN(val)) onChange(val);else onChange(parseInt(val, 10));
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'campaign-item-options ' + (hover ? 'hover_on' : ''),
    onClick: onClick ? function () {
      return onClick(props.value);
    } : undefined
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "campaign-item-options__container ".concat(props.campaignType === 'associate' ? 'double_icon' : '')
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "campaign-item-option ".concat(checked ? 'checked' : '', " ").concat(props.campaignType)
  }, onChange && /*#__PURE__*/_react["default"].createElement("input", {
    type: "radio",
    name: "rad1",
    value: props.value,
    checked: checked,
    onChange: changeHandler
  }), /*#__PURE__*/_react["default"].createElement("i", {
    className: props.campaignType === 'inbound' ? 'gcl-icon arrow-in' : 'gcl-icon arrow-out'
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "campaign-item-option-checked"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon selected"
  }))), props.campaignType === 'associate' && /*#__PURE__*/_react["default"].createElement("label", {
    className: "campaign-item-option ".concat(checked ? 'checked' : '', " inbound")
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon arrow-in"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "campaign-item-option-checked"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon selected"
  })))), props.label && /*#__PURE__*/_react["default"].createElement("p", {
    className: "campaign-item__label"
  }, props.label));
};

CampaignItemOption.propTypes = {
  id: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
  label: _propTypes["default"].string,
  name: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  onClick: _propTypes["default"].func,
  checked: _propTypes["default"].bool,
  hover: _propTypes["default"].bool,
  campaignType: _propTypes["default"].string
};
var _default = CampaignItemOption;
exports["default"] = _default;